import React from "react";
import { styled } from '@mui/material/styles';
import heroStyles from './HeroStyles';

const posts = [
  {
    id: 1,
    title: 'Guía completa para elegir la caja seca ideal según tu tipo de carga',
    href: '/blog/guia-para-elegir-caja-seca-ideal',
    description:
      'Descubre cómo seleccionar el equipo perfecto para tu operación. En este artículo explicamos las diferencias entre cajas secas de 48 y 53 pies, cuándo conviene una plataforma o cama baja, y qué factores debes considerar según el tipo de mercancía, ruta y volumen. Ideal para quienes buscan ahorrar tiempo, evitar daños y optimizar costos logísticos.',
    date: 'Dic 16, 2025',
    datetime: '2020-03-16',
    category: { title: 'Marketing', href: '/blog/guia-para-elegir-caja-seca-ideal' },
    author: {
      name: 'Hugo Osorio',
      role: 'Especialista de Marketing',
      href: '/blog/guia-para-elegir-caja-seca-ideal',
      imageUrl:
        'https://grupogm-assets.s3.us-east-1.amazonaws.com/blog-avatar-hugo.jpg',
    },
  },
  {
    id: 2,
    title: 'Requisitos y mejores prácticas para transportar carga en México en 2025',
    href: '/blog/requisitos-para-transportar-carga-en-mexico',
    description: 'Mantente al día con la normativa actual. Aquí te mostramos los documentos obligatorios, recomendaciones de seguridad, regulaciones básicas de la SCT y las mejores prácticas para operar de forma segura y eficiente en rutas nacionales. Perfecto para empresas, transportistas y operadores que quieren evitar multas y mejorar sus operaciones.',
    date: 'Jun 10, 2025',
    datetime: '2020-03-10',
    category: { title: 'Ventas', href: '/blog/requisitos-para-transportar-carga-en-mexico' },
    author: {
      name: 'Alejandra Gayosso',
      role: 'Directora Administrativa',
      href: '/blog/requisitos-para-transportar-carga-en-mexico',
      imageUrl:
        'https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
  },
  {
    id: 3,
    title: 'Cómo ahorrar costos logísticos rentando cajas secas en lugar de comprarlas',
    href: '/blog/como-ahorrar-costos-rentando-cajas-secas',
    description:
      'Rentar puede ser más rentable de lo que imaginas. Este artículo compara costos entre renta y compra, muestra cómo la renta ofrece flexibilidad operativa y explica en qué casos conviene una u otra opción. Una lectura muy útil para empresas en crecimiento o quienes buscan optimizar presupuesto sin sacrificar calidad.',
    date: 'Oct 12, 2025',
    datetime: '2020-02-12',
    category: { title: 'Negocio', href: '/blog/como-ahorrar-costos-rentando-cajas-secas' },
    author: {
      name: 'Mariana Osorio',
      role: 'Coordinadora Administrativa',
      href: '/blog/como-ahorrar-costos-rentando-cajas-secas',
      imageUrl:
        'https://grupogm-assets.s3.us-east-1.amazonaws.com/blog-avatar-mariana.jpg',
    },
  },
  {
    id: 4,
    title: 'Zonas estratégicas de operación en Hidalgo y centro del país: ventajas logísticas y rutas clave',
    href: '/blog/zonas-estrategicas-de-operacion-en-hidalgo',
    description:
      'Explora las ventajas de operar en Hidalgo y sus conexiones con CDMX, EdoMex y Querétaro. Explicamos los puntos clave de movimiento, rutas eficientes, tipos de carga más comunes por zona y cómo una empresa local puede reducir tiempos y costos. Ideal para clientes que buscan logística rápida en la región.',
    date: 'Sep 12, 2025',
    datetime: '2020-02-12',
    category: { title: 'Ventas', href: '/blog/zonas-estrategicas-de-operacion-en-hidalgo' },
    author: {
      name: 'Lucio Gayosso',
      role: 'Director Operativo',
      href: '/blog/zonas-estrategicas-de-operacion-en-hidalgo',
      imageUrl:
        'https://images.unsplash.com/photo-1491528323818-fdd1faba62cc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
  },
  {
    id: 5,
    title: 'Errores comunes al rentar una caja seca y cómo evitarlos',
    href: '/blog/errores-comunes-al-rentar-una-caja-seca',
    description:
      'Explora las ventajas de operar en Hidalgo y sus conexiones con CDMX, EdoMex y Querétaro. Explicamos los puntos clave de movimiento, rutas eficientes, tipos de carga más comunes por zona y cómo una empresa local puede reducir tiempos y costos. Ideal para clientes que buscan logística rápida en la región.',
    date: 'Sep 12, 2025',
    datetime: '2020-02-12',
    category: { title: 'Negocio', href: '/blog/errores-comunes-al-rentar-una-caja-seca' },
    author: {
      name: 'Hugo Osorio',
      role: 'Especialista de Marketing',
      href: '/blog/errores-comunes-al-rentar-una-caja-seca',
      imageUrl:
        'https://grupogm-assets.s3.us-east-1.amazonaws.com/blog-avatar-hugo.jpg',
    },
  },
]

const StyledHero = styled('section')(({ theme }) => heroStyles);

export default function Hero() {
  return (
    <StyledHero className="pb-24 pt-36 sm:pb-32 sm:pt-48">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 id="hero-title" className="text-4xl font-semibold tracking-tight text-pretty sm:text-5xl">Nuestro blog</h2>
          <p id="hero-description" className="mt-2 text-lg/8">Aprende cómo hacer crecer tu negocio con nuestros consejos expertos.</p>
        </div>
        <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 border-solid border-0 border-t border-gray-400 pt-10 sm:mt-16 sm:pt-16 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {posts.map((post) => (
            <article key={post.id} className="flex max-w-xl flex-col items-start justify-between">
              <div className="flex items-center gap-x-4 text-xs">
                <time dateTime={post.datetime} className="text-gray-400">
                  {post.date}
                </time>
                <a
                  href={post.category.href}
                  className="relative z-10 rounded-full bg-gray-800/60 px-3 py-1.5 font-medium text-white hover:bg-gray-800"
                >
                  {post.category.title}
                </a>
              </div>
              <div className="group relative grow">
                <h3 className="mt-3 text-lg/6 font-semibold text-white group-hover:text-gray-300">
                  <a href={post.href}>
                    <span className="absolute inset-0" />
                    {post.title}
                  </a>
                </h3>
                <p className="mt-5 line-clamp-3 text-sm/6 text-gray-400">{post.description}</p>
              </div>
              <div className="relative mt-8 flex items-center gap-x-4 justify-self-end">
                <img loading="lazy" alt="" src={post.author.imageUrl} className="size-10 rounded-full bg-gray-800" />
                <div className="text-sm/6">
                  <p className="font-semibold text-white">
                    <a href={post.author.href}>
                      <span className="absolute inset-0" />
                      {post.author.name}
                    </a>
                  </p>
                  <p className="text-gray-400">{post.author.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </StyledHero>
  )
}
